/* globals google */
const StoreLocatorOptions = require('./storelocator.json');
const hoursTooltip = require('../components/hoursPopup');
const googleAddress = require('../components/googleaddress');
const dataLayer = require('../dataLayer/dataLayer');
const media = require('../components/utils/media');
// Bind Google Address locator
$(document).ready(() => {
    googleAddress.init();
});

const $emptySearch = $('.js-store-locator-emptysearch');
const $noResults = $('.js-store-locator-page-no-results');

/**
 * appends params to a url
 * @param {string} url - Original url
 * @param {Object} params - Parameters to append
 * @returns {string} result url with appended parameters
 */
function appendToUrl(url, params) {
    let newUrl = url;
    newUrl += (newUrl.indexOf('?') !== -1 ? '&' : '?') +
        Object.keys(params).map(key => `${key}=${encodeURIComponent(params[key])}`).join('&');

    return newUrl;
}

/**
 * Uses google maps api to render a map
 *  @param {*} center - Google Maps LatLng
 *  @returns {void}
 */
function maps(center) {
    const infowindow = new google.maps.InfoWindow();
    const location = center || StoreLocatorOptions.center;
    // Init Canada Map in the center of the viewport
    const { mapOptions } = StoreLocatorOptions;
    mapOptions.center = location;
    const map = new google.maps.Map($('.map-canvas')[0], mapOptions);

    let mapdiv = $('.map-canvas').attr('data-locations');

    // read the brand id from data attribute
    let mappin = $('.map-canvas').attr('data-currentbrand');

    mapdiv = mapdiv ? JSON.parse(mapdiv) : '';

    const bounds = new google.maps.LatLngBounds();

    // get the brand spcific svg path definition from the json file
    var markerImg = StoreLocatorOptions[mappin];

    // Customized google map marker icon with svg format
    //const { markerImg } = StoreLocatorOptions;
    markerImg.anchor = new google.maps.Point(13, 30);
    markerImg.labelOrigin = new google.maps.Point(12, 12);

    const markers = [];

    Object.keys(mapdiv).forEach((key) => {
        const item = mapdiv[key];
        const storeLocation = new google.maps.LatLng(item.latitude, item.longitude);
        const marker = new google.maps.Marker({
            position: storeLocation,
            map,
            title: item.name,
            icon: markerImg
        });
        markers.push(marker);
        marker.addListener('click', () => {
            const htmlNodes = $.parseHTML(item.infoWindowHtml);

            let storeId = $(htmlNodes).filter('div.b-locator_map-popup').children('.store-details').data('store-id');

            if (storeId) {
                $('.js-card-body-locator').removeClass('b-locator_card_selected');
                $(`.js-card-body-locator[id="${storeId}"]`).addClass('b-locator_card_selected');
            }
            infowindow.setOptions({
                content: item.infoWindowHtml
            });
            infowindow.open(map, marker);
        });

        google.maps.event.addListener(infowindow, 'closeclick', () => {
            $('.js-card-body-locator').removeClass('b-locator_card_selected');
        });

        // Create a minimum bound based on a set of storeLocations
        bounds.extend(marker.position);
    });

    if (mapdiv && mapdiv.length !== 0) {
        if (!center) {
            // Fit the all the store marks in the center of a minimum bounds when any store has been found.
            map.fitBounds(bounds);
        } else {
            // Center the map to selected marker
            map.setCenter(center);
            map.setZoom(18);
            $('.map-canvas').attr('tabindex', -1);
            $('.map-canvas').focus();
            const selected = markers.find(e => e.position.lat().toFixed(2) === center.lat.toFixed(2) &&
             e.position.lng().toFixed(2) === center.lng.toFixed(2));
            if (selected) {
                google.maps.event.trigger(selected, 'click');
            }
        }
    }
}
/**
 * Gets address location using Google Maps Geocoder
 *
 * @param {*} address
 * @returns {*} result
 */
function geocodeAddress(address) {
    // Init geocoder
    const geocoder = new google.maps.Geocoder();

    return new Promise((resolve, reject) => {
        geocoder.geocode({ address }, (results, status) => {
            if (status === 'OK') {
                resolve(results[0].geometry.location);
            } else {
                reject(new Error(address));
            }
        });
    });
}


/**
 * Renders the results of the search and updates the map
 * @param {object} data - Response from the server
 */
function updateStoresResults(data) {
    const $resultsDiv = $('.js-stores-locator-page-results');
    const $mapDiv = $('.map-canvas');
    const hasResults = data.stores.length > 0;

    $noResults.toggleClass('h-hidden', hasResults);

    if (data.isEmptyQuery) {
        $noResults.addClass('h-hidden');
        $emptySearch.removeClass('h-hidden');
    }

    $resultsDiv.empty()
        .data('has-results', hasResults)
        .data('radius', data.radius)
        .data('search-key', data.searchKey);

    if (data.storesResultsHtml) {
        $resultsDiv.append(data.storesResultsHtml);
    }

    $mapDiv.attr('data-locations', data.locations || '');
    maps();
}

/**
 * Appends the results of the search and updates the map
 * @param {object} data - Response from the server
 */
function appendStoresResults(data) {
    const $resultsDiv = $('.js-stores-locator-page-results');
    const $mapDiv = $('.map-canvas');

    if (data.storesResultsHtml) {
        $resultsDiv.append(data.storesResultsHtml);
    }

    $mapDiv.attr('data-locations', data.locations);
    maps();
}

/**
 * Search for stores with new zip code
 *
 * @param {*} element
 * @returns {boolean} false to prevent default event
 */
function getNextPage(element) {
    const $pagingOptions = $(element);

    let url = $pagingOptions.data('actionUrl') + '&place=storeLocator';

    if (url) {
        const payload = {};
        $.ajax({
            url,
            type: 'GET',
            data: payload,
            dataType: 'json',
            success(data) {
                appendStoresResults(data);
            }
        });
    }
    return false;
}

/**
 * Search for stores with new zip code
 * @param {JQuery} element - the target html element
 * @returns {boolean} false to prevent default event
 */
function search(element) {
    const dialog = element.closest('.js-store-inventory-body');
    const spinner = dialog.length ? dialog.spinner() : $('.js-storelocator-map').spinner();
    spinner.start();
    const $form = element.closest('.store-locator');

    const radius = $form.find('.js-radius option:selected').val();
    let url = $form.attr('action');

    const urlParams = { radius, isMobile: media.getBreakpoint() !== 'large' };
    const query = $form.find('[name="postalCode"]').val();
    if (query) {
        $emptySearch.addClass('h-hidden');
        geocodeAddress(query).then((position) => {
            urlParams.lat = position.lat();
            urlParams.lng = position.lng();

            // const payload = { postalCode: $form.find('[name="postalCode"]').val() };
            const payload = {};

            url = appendToUrl(url, urlParams);
            $.ajax({
                url,
                type: $form.attr('method'),
                data: payload,
                dataType: 'json',
                success(data) {
                    spinner.stop();
                    updateStoresResults(data);
                }
            });
        }).catch(() => {
            spinner.stop();
            updateStoresResults({
                stores: [],
                locations: ''
            });
        });
    } else {
        spinner.stop();
        updateStoresResults({
            stores: [],
            locations: '',
            isEmptyQuery: true
        });
    }

    return false;
}

function detectLocationAndRenderMap() {
    if (!navigator.geolocation) {
        return;
    }

    const $storeLocatorMap = $('.js-storelocator-map');
    $storeLocatorMap.spinner().start();

    $storeLocatorMap.spinner().start();
    navigator.geolocation.getCurrentPosition(position => {
        // Hide empty query error
        $emptySearch.addClass('h-hidden');
        const $detectLocationButton = $('.js-detect-location-store-locator');
        const url = $detectLocationButton.data('action');
        const radius = $('.js-radius').val();
        const urlParams = {
            radius,
            lat: position.coords.latitude,
            lng: position.coords.longitude
        };

        $.ajax({
            url,
            type: 'get',
            dataType: 'json',
            data: urlParams,
            timeout: 6000,
            success(data) {
                $storeLocatorMap.spinner().stop();
                updateStoresResults(data);
                $('.js-select-store').prop('disabled', false);
            }
        }).always(()=>{
            $storeLocatorMap.spinner().stop();
        });
    }, () => {
        $storeLocatorMap.spinner().stop();
    });
}
module.exports = {
    init() {
        if ($('.map-canvas').data('has-google-api')) {
            detectLocationAndRenderMap();
        } else {
            $('.store-locator-no-apiKey').show();
        }
    },

    detectLocation() {
        // clicking on detect location.
        $('.js-detect-location-store-locator').on('click', (() => {
            dataLayer.storeLocatorEvent('Use my location');
            detectLocationAndRenderMap();
        }));
    },

    search() {
        $('.js-store-locator-page-container form.store-locator').submit(function (e) {
            e.preventDefault();
            search($(this));
        });
        $('.js-store-locator-page-container .btn-storelocator-search[type="button"]').click(function (e) {
            e.preventDefault();
            dataLayer.storeLocatorEvent('FInd Store');
            search($(this));
        });
    },

    changeRadius() {
        $('.js-store-locator-page-container .js-radius').change(function () {
            const radius = $(this).children('option:selected').val();
            $('.js-stores-locator-page-results').data('radius', radius);
            if ($('#store-postal-code').val()) {
                search($('.store-locator-container .btn-storelocator-search[type="button"]'));
            }
        });
    },
    selectStore() {
        $('.js-card-body').on('click', '.btn-storelocator-viewonmap', ((e) => {
            e.preventDefault();
            const locationInfo = $(e.target).data('location-info');
            maps(locationInfo);
        }));
    },
    displayHours() {
        hoursTooltip.initHoursPopup();
    },
    updateSelectStoreButton() {
        $('body').on('change', '.js-select-store-input', (() => {
            $('.js-select-store').prop('disabled', false);
        }));
    },
    loadMoreStores() {
        $('.js-card-body').on('click', '.js-storelocator-page-loadmore', ((e) => {
            e.preventDefault();
            getNextPage(e.currentTarget);
            e.currentTarget.remove();
        }));
    }
};
